import { useRequest } from '@hooks';
import { Select } from 'antd';
import { useNotify } from 'react-admin';
import { useListContext } from 'ra-core';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import { cropStateHttp } from '@network';
import { useModalContext } from '@providers';
import { BlueButton, BlueOutlineButton } from '@components';
import { statesByCode, statesByCodeKeys } from '@types';

export const CropStateActions = () => {
  const notify = useNotify();
  const { hideModal } = useModalContext();
  const { selectedIds, refetch } = useListContext();
  const [prop, setProp] = useState<string>();
  const [value, setValue] = useState<string | number | null>(null);
  const cls = useStyles();

  const resetValues = () => {
    setValue(null);
  };

  const onCancel = () => {
    setProp(undefined);
    resetValues();
    hideModal();
  };

  const { loading, submit } = useRequest(async () => {
    if (!Array.isArray(selectedIds) || selectedIds.length === 0) {
      return notify('No records are selected');
    }
    if (!prop) {
      return notify('No property is selected');
    }

    const updatedTotal = await cropStateHttp.updateBulk({ selectedIds, prop, value });

    notify(`Updated records: ${updatedTotal}`);
    onCancel();
    refetch();
  });

  useEffect(() => {
    resetValues();
  }, [prop]);

  return (
    <div className={cls.box}>
      <div className={cls.title}>Properties to update</div>
      <Select value={prop} onChange={v => setProp(v)} className={cls.select}
        placeholder="Select a property to edit">
        {statesByCodeKeys.map(stateCode => (
          <Select.Option key={stateCode} value={`state${stateCode}`}>
            {statesByCode[stateCode]}
          </Select.Option>
        ))}
      </Select>

      <div className={cls.content}>
        <div className={cls.title}>
          <div>{statesByCodeKeys[(prop ?? '').replace('state', '')]}</div>
        </div>
        <Select value={value} onChange={v => setValue(v)} className={cls.select}
          placeholder="Crop fertility">
          {['A', 'B', 'C', 'D', 'E'].map(grade => (
            <Select.Option key={grade} value={grade}>
              {grade}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div className={cls.controls}>
        <BlueButton className={cls.btn} onClick={submit} disabled={loading}>Update</BlueButton>
        <BlueOutlineButton className={cls.btn} onClick={onCancel}>Cancel</BlueOutlineButton>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  box: {},
  title: {
    fontSize: 20,
    lineHeight: 1,
    fontWeight: 500,
    color: 'var(--title-color)',
  },
  select: {
    marginTop: 10,
    width: '100%',
    borderRadius: 8,
    border: '1px solid #E0E7EE',
    backgroundColor: 'var(--background-color)',
    '& .ant-select-selector': {
      backgroundColor: 'transparent !important',
    },
  },
  content: {
    marginTop: 15,
  },
  controls: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  btn: {
    margin: '0 7px',
    padding: '5px 29px !important',
    height: 34,
    borderRadius: 8,
    textTransform: 'none',
  },
});
